// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__3iYPt","noposts":"Dashboard_noposts__fJGXu","post_header":"Dashboard_post_header__XsNOd","post_row":"Dashboard_post_row__OugKr"};